export const allMenu = [
    {
        name: '迎新现场',
        key: 'yxxc',
        url: '/yxxc',
        icon: 'team',
        auth: 'zhxg_yxgl_yxxc:menu',
    },
    /*{
        name: '刷脸报到成功',
        key: 'success',
        url: '/success',
        icon: 'scan'
    },*/
    {
        name: '人脸识别报到',
        key: 'face',
        url: '/face',
        icon: 'scan',
        auth: 'zhxg_yxgl_rlsb:menu',
    },
    {
        name: '基础数据管理',
        key: 'jcsj',
        icon: 'hdd',
        children: [
            {
                name: '新生数据管理',
                url: '/newStudent',
                key: 'newStudent',
                auth: 'zhxg_yxgl_jcsj_xssjgl:menu',
            }, {
                name: '未报到学生管理',
                key: 'wbdStudent',
                url: '/wbdStudent',
                auth: 'zhxg_yxgl_jcsj_wbdxsgl:menu',
            }
            // , {
            //     name: '新生照片管理',
            //     key: 'xszpgl',
            //     url: '/xszpgl',
            //     auth: 'zhxg_yxgl_jcsj_xszpgl:menu',
            // }
        ]
    }, {
        name: '迎新流程管理',
        key: 'lcgl',
        icon: 'file-text',
        children: [
            {
                name: '环节管理',
                url: '/hjgl',
                key: 'hjgl',
                auth: 'zhxg_yxgl_lcgl_hjgl:menu',
            }, {
                name: '流程配置',
                url: '/lcpz',
                key: 'lcpz',
                auth: 'zhxg_yxgl_lcgl_lcpz:menu',
            }, {
                name: '环节分配',
                url: '/hjfp',
                key: 'hjfp',
                auth: 'zhxg_yxgl_lcgl_hjfp:menu',
            }
        ]
    }, {
        name: '统计查询',
        key: 'tjcx',
        icon: 'desktop',
        children: [
            {
                name: '学生报到统计',
                url: '/bdtjcx',
                key: 'bdtjcx',
                auth: 'zhxg_yxgl_tjcx_bdtjcx:menu',
            }, {
                name: '学生信息查询',
                url: '/xsxxcx',
                key: 'xsxxcx',
                auth: 'zhxg_yxgl_tjcx_xsxxcx:menu',
            }, {
                name: '学生缴费信息查询',
                url: '/xsjfxxcx',
                key: 'xsjfxxcx',
                auth: 'zhxg_yxgl_tjcx_xsjfxxcx:menu',
            }, {
                name: '学生缴费查询统计',
                url: '/xsjfcxtj',
                key: 'xsjfcxtj',
                auth: 'zhxg_yxgl_tjcx_xsjfcxtj:menu',
            }, {
                name: '学生住宿信息查询',
                url: '/zsxxcx',
                key: 'zsxxcx',
                auth: 'zhxg_yxgl_tjcx_zsxxcx:menu',
            }, {
                name: '环节办理查询',
                url: '/hjblcx',
                key: 'hjblcx',
                auth: 'zhxg_yxgl_tjcx_hjblcx:menu',
            }, {
                name: '环节办理详情查询',
                url: '/hjblxqcx',
                key: 'hjblxqcx',
                auth: 'zhxg_yxgl_tjcx_hjblxqcx:menu',
            }, {
                name: '环节办理业务项查询',
                url: '/hjblywxcx',
                key: 'hjblywxcx',
                auth: 'zhxg_yxgl_tjcx_hjblywxcx:menu',
            }, {
                name: '自助报到统计',
                url: '/zzbdtjcx',
                key: 'zzbdtjcx',
                auth: 'zhxg_yxgl_tjcx_zzbdtjcx:menu',
            }, {
                name: '自助报到查询',
                url: '/bdqkcx',
                key: 'bdqkcx',
                auth: 'zhxg_yxgl_tjcx_bdqkcx:menu',
            }, {
                name: '自助报到办理查询',
                url: '/zzbdblcx',
                key: 'zzbdblcx',
                auth: 'zhxg_yxgl_tjcx_zzbdblcx:menu',
            }, {
                name: '学生信息采集查询',
                url: '/xsxxcjcx',
                key: 'xsxxcjcx',
                auth: 'zhxg_yxgl_tjcx_xsxxcjcx:menu',
            }, {
                name: '生活用品查询',
                url: '/shypcx',
                key: 'shypcx',
                auth: 'zhxg_yxgl_tjcx_shypcx:menu',
            }, {
                name: '军训服装查询',
                url: '/jxfzcx',
                key: 'jxfzcx',
                auth: 'zhxg_yxgl_tjcx_jxfzcx:menu',
            }, {
                name: '校服服装查询',
                url: '/xffzcx',
                key: 'xffzcx',
                auth: 'zhxg_yxgl_tjcx_xffzcx:menu',
            }, {
                name: '绿色通道查询',
                url: '/lstdblcx',
                key: 'lstdblcx',
                auth: 'zhxg_yxgl_tjcx_lstdblcx:menu',
            }
        ]
    }, {
        name: '服务网管理',
        key: 'fwwgl',
        icon: 'coffee',
        children: [
            {
                name: '导航栏目',
                url: '/dhlm',
                key: 'dhlm',
                auth: 'zhxg_yxgl_fwwgl_dhlmgl:menu',
            }, {
                name: '首页图片',
                url: '/sytp',
                key: 'sytp',
                auth: 'zhxg_yxgl_fwwgl_sytp:menu',
            }, {
                name: '首页链接',
                url: '/sylj',
                key: 'sylj',
                auth: 'zhxg_yxgl_fwwgl_syljgl:menu',
            }, {
                name: '信息发布',
                url: '/xxfb',
                key: 'xxfb',
                auth: 'zhxg_yxgl_fwwgl_xxfb:menu',
            }, {
                name: '报到流程',
                url: '/bdlc',
                key: 'bdlc',
                auth: 'zhxg_yxgl_fwwgl_bdlc:menu',
            }, {
                name: '快速导航',
                url: '/ksdh',
                key: 'ksdh',
                auth: 'zhxg_yxgl_fwwgl_ksdh:menu',
            }, {
                name: '联系方式',
                url: '/lxfs',
                key: 'lxfs',
                auth: 'zhxg_yxgl_fwwgl_lxfs:menu',
            }, {
                name: '在线问答',
                url: '/zxwd',
                key: 'zxwd',
                auth: 'zhxg_yxgl_fwwgl_zxwd:menu',
            }, {
                name: '自助报到',
                url: '/zzbd',
                key: 'zzbd',
                auth: 'zhxg_yxgl_fwwgl_zzbd:menu',
            }, {
                name: '生活物品管理',
                url: '/shwpgl',
                key: 'shwpgl',
                auth: 'zhxg_yxgl_fwwgl_shwpgl:menu',
            }, {
                name: '站台维护',
                url: '/ztwh',
                key: 'ztwh',
                auth: 'zhxg_yxgl_fwwgl_ztwh:menu',
            }
        ]
    },
    {
        name: '信息采集',
        key: 'xxcj',
        icon: 'edit',
        children: [
            {
                name: '表单管理',
                url: '/bdgl',
                key: 'bdgl',
                auth: 'zhxg_yxxt_xxcj_bdgl:menu'
            },
            {
                name: '字段管理',
                url: '/zdgl',
                key: 'zdgl',
                auth: 'zhxg_yxxt_xxcj_zdgl:menu'
            }
        ]
    }, {
        name: '事务办理',
        key: 'swbl',
        icon: 'solution',
        children: [
            {
                name: '绿色通道审核',
                url: '/lstd',
                key: 'lstd',
                auth: 'zhxg_yxgl_swbl_lstd:menu',
            },{
                name: '绿色通道明细',
                url: '/lstdmx',
                key: 'lstdmx',
                auth: 'zhxg_yxgl_swbl_lstdtj:menu',
            },{
                name: '绿色通道统计',
                url: '/lstdtj',
                key: 'lstdtj',
                auth: 'zhxg_yxgl_swbl_lstdtj:menu',
            }, {
                name: '专业调整',
                url: '/zytz',
                key: 'zytz',
                auth: 'zhxg_yxgl_swbl_zytz:menu',
            },
        ]
    }, {
        name: '在线缴费管理',
        key: 'zxjfgl',
        icon: 'pay-circle',
        children: [
            {
                name: '缴费方案管理',
                url: '/jffagl',
                key: 'jffagl',
                auth: 'zhxg_yxxt_zxjfgl_jffagl:menu',
            },
            {
                name: '缴费参数设置',
                url: '/jfcssz',
                key: 'jfcssz',
                auth: 'zhxg_yxxt_zxjfgl_jfcssz:menu',
            },
        ]
    }, {
        name: '实时统计',
        key: 'sstj',
        icon: 'bar-chart',
        children: [
            {
                name: '本科生迎新实时数据统计',
                key: 'show',
                url: '/show',
                auth: 'zhxg_yxgl_sstj:menu',
            },
            {
                name: '研究生迎新实时数据统计',
                key: 'sstj_bxcc',
                url: '/show-zzsd',
                auth: 'zhxg_yxgl_sstj_bxcc:menu',
            },
            {
                name: '迎新实时数据统计',
                key: 'sstj_bgy',
                url: '/bgy-show',
                auth: 'zhxg_yxgl_sstj_bgy:menu',    
            }
        ]
    }

]


// WEBPACK FOOTER //
// ./utils/menu.js